import React from 'react';
import LessonHome from '../LessonHome';

const Lesson6 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson6;